import Image from 'next/image';
import Link from 'next/link';

export const Arrival = () => {
  const keyStr =
  "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
  const triplet = (e1, e2, e3) =>
    keyStr.charAt(e1 >> 2) +
    keyStr.charAt(((e1 & 3) << 4) | (e2 >> 4)) +
    keyStr.charAt(((e2 & 15) << 2) | (e3 >> 6)) +
    keyStr.charAt(e3 & 63);
  
  const rgbDataURL = (r, g, b) =>
    `data:image/gif;base64,R0lGODlhAQABAPAA${
      triplet(0, r, g) + triplet(b, 255, 255)
    }/yH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==`;
  
  return (
    <div className="w-full  py-6">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 max-w-screen-xl mx-auto px-4">
        {/* Large Image with Content */}
        <div className="relative bg-white h-full rounded-lg shadow-md overflow-hidden lg:col-span-2">
          <Image
            src="/Images/new_arr3.webp" // Replace with actual image path
             alt="Mystical Fragrance - Luxury Perfume "
            // layout="fill"
            objectFit="cover" 
            width={1000}
            height={1000}
            placeholder="blur"
            blurDataURL={rgbDataURL(234,225,221)}
            className="w-full h-full "
          />
          <div className="absolute bottom-4 left-4 bg-darkBlack bg-opacity-50 text-pureWhite p-4 rounded-md">
            <h2 className="text-xl font-semibold">ARMAF Club De Nuit Milestone Made In UAE</h2>
            <Link href={'/products/ARMAF-Club-De-Nuit-Milestone-Eau-De-Parfum-67c7ea81b3171a32035d07a1'}>
              <button className="mt-2 px-4 py-2 bg-[#fff] font-bold rounded text-darkBlack">Shop Now</button>
              </Link>
          </div>
        </div>

        {/* Small Images with Content */}
        <div className="space-y-6">
          <div className="relative bg-white rounded-lg shadow-md overflow-hidden">
            <Image
              src="/Images/new_arr2.png" // Replace with actual image path
              alt="Elegant Perfume Bottle"
              layout="responsive"
              width={1000}
              height={1000}
              placeholder="blur"
              blurDataURL={rgbDataURL(234,225,221)}
              className="w-full h-auto object-contain"
            />
            <div className="absolute bottom-4 left-4 bg-darkBlack bg-opacity-50 text-pureWhite p-4 rounded-md">
              <h2 className="text-xl font-semibold">Nabeel Al Bashiq Made In UAE</h2>

              <Link href={'/products/Nabeel-Al-Bashiq-Eau-De-parfum-100ML-67c7f6e560179272ab2552a6'}>
              <button className="mt-2 px-4 py-2 bg-[#fff] font-bold rounded text-darkBlack">Shop Now</button>
              </Link>
            </div>
          </div>

          <div className="relative bg-white rounded-lg shadow-md overflow-hidden">
            <Image
              src="/Images/new_arr1.webp" // Replace with actual image path
              alt="Rose Perfume"
              layout="responsive"
              width={1000}
              height={1000}
              placeholder="blur"
              blurDataURL={rgbDataURL(234,225,221)}
              className="w-full h-auto object-contain"
            />
            <div className="absolute bottom-4 left-4 bg-darkBlack bg-opacity-50 text-pureWhite p-4 rounded-md">
              <h2 className="text-xl font-semibold">ARMAF Tag Her Women Made In UAE</h2>
              <Link href={'products/ARMAF-TAG-HER-Women-Eau-De-Parfum-(100ML)-67c7e3fcbb07863d44aff6be'}>
              <button className="mt-2 px-4 py-2 bg-[#fff] font-bold rounded text-darkBlack">Shop Now</button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
